/**
 * Codifica el nombre de una fase usando base64 para evitar
 * la manipulación casual del parámetro en la URL del navegador.
 * @param {string} fase - Nombre de la fase (ej. "P16-F02")
 * @returns {string} Cadena codificada en base64
 */
export function encodeFase(fase) {
  if (!fase) return fase;
  return btoa(fase);
}

/**
 * Decodifica el parámetro de fase desde base64.
 * Si el valor no es base64 válido (ej. URL manipulada o valor plano),
 * devuelve el valor original como fallback.
 * @param {string} encoded - Valor del query param ?fase=
 * @returns {string} Nombre de la fase decodificado
 */
export function decodeFase(encoded) {
  if (!encoded) return encoded;
  try {
    return atob(encoded);
  } catch {
    return encoded;
  }
}
